import React from 'react';
import { useNavigate } from 'react-router';
import Button from './Button';

function BackButton() {
  const navigate = useNavigate();

  const onClick = () => {
    navigate('/');
  };
  return (
    <Button className="home submit pixel-corners" onClick={onClick}>
      <span className="arrow">v</span>BACK
    </Button>
  );
}

export default BackButton;
